import { render, staticRenderFns } from "./bulkBillings.vue?vue&type=template&id=62251242&scoped=true"
import script from "./bulkBillings.vue?vue&type=script&lang=js"
export * from "./bulkBillings.vue?vue&type=script&lang=js"
import style0 from "./bulkBillings.vue?vue&type=style&index=0&id=62251242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62251242",
  null
  
)

export default component.exports